module.exports = __webpack_public_path__ + "img/chat_bot_1.702f8b25.png";